module.exports = __webpack_public_path__ + "img/banner-1.26617a81.jpg";